import React, { createContext, useState, useContext } from 'react';
import { CalculatorInput, CalculatorResult } from '../types/calculator';
import { calculateProfits } from '../utils/calculations';
import { products } from '../data/products';

interface CalculatorContextType {
  input: CalculatorInput;
  results: CalculatorResult;
  setAmount: (amount: number) => void;
  setProduct: (productId: string) => void;
  reset: () => void;
}

const defaultInput: CalculatorInput = {
  amount: 9000,
  product: products[0].id
};

const CalculatorContext = createContext<CalculatorContextType | undefined>(undefined);

export const CalculatorProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [input, setInput] = useState<CalculatorInput>(defaultInput);
  const [results, setResults] = useState<CalculatorResult>(() => 
    calculateProfits(defaultInput)
  );
  
  const setAmount = (amount: number) => {
    const newInput = { ...input, amount };
    setInput(newInput);
    setResults(calculateProfits(newInput));
  };
  
  const setProduct = (productId: string) => {
    const newInput = { ...input, product: productId };
    setInput(newInput);
    setResults(calculateProfits(newInput));
  };
  
  const reset = () => {
    setInput(defaultInput);
    setResults(calculateProfits(defaultInput));
  };
  
  return (
    <CalculatorContext.Provider value={{ input, results, setAmount, setProduct, reset }}>
      {children}
    </CalculatorContext.Provider>
  );
};

export const useCalculator = (): CalculatorContextType => {
  const context = useContext(CalculatorContext);
  if (context === undefined) {
    throw new Error('useCalculator must be used within a CalculatorProvider');
  }
  return context;
};
